export default __webpack_public_path__ + "static/carousel-14-035fc620fc6e62bc29fcfd81441f34b0.jpg";